<template>
  <f7-page name="meteo-vystrahy" @page:init="onPageInit" @page:beforeout="onPageBeforeOut" @page:beforeremove="onPageBeforeRemove">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>Meteo výstrahy</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>

    <f7-toolbar tabbar bottom>
      <f7-link tab-link="#tab-mv-okres" tab-link-active>Okres</f7-link>
      <f7-link tab-link="#tab-mv-map" >Mapa</f7-link>
    </f7-toolbar>

    <f7-tabs class="wh-100">
      <f7-tab id="tab-mv-okres" @tab:show="onTableTabShow($event)" tab-active>
        <f7-block strong class="no-padding no-margin no-border-top">
          <template v-if="isRegionsLoaded">
            <f7-list class="ss-list">
              <f7-list-item title="Okres:"
                            class="meteo-vystrahy-ss-list"
                            smart-select
                            :smart-select-params="{openIn: 'popup', scrollToSelectedItem:true, closeOnSelect: true, pageTitle:'Vyberte okres', popupCloseLinkText:'Návrat', searchbar: {  removeDiacritics:true, customSearch: true, on: { search: searchFromBeginning }, }, searchbarPlaceholder: 'Hľadať...'}">
                <select name="station" v-model="selectedRegion" @change="onSelectForecast($event)">
                  <option v-for="(value, key) in regions" :key="key" :value="value.region_key">{{ value.region_popis }}</option>
                </select>
                <div slot="root-start" class="float-left" style="margin: 3px;" v-if="isGeolocationEnabled">
                  <f7-button @click="selectOkresByLocation" class="text-color-black" icon-f7="placemark_fill"></f7-button>
                </div>
              </f7-list-item>
            </f7-list>
            <f7-block v-if="selectedRegion !== null" class="no-margin no-padding">

              <template v-if="isDataLoaded && !notEmptyObject(warningData)">
                <f7-block strong class="text-align-center no-margin-top vystraha-0">
                  Pre okres <strong>{{ currentRegion.region_popis }}</strong> nie sú vydané žiadne meteorologické výstrahy
                </f7-block>
              </template>
              <template v-else-if="isDataLoaded && notEmptyObject(warningData)">
                <f7-card v-for="(vystraha, index) in warningData.vystrahy" :key="index">
                  <f7-card-header :class="'vystraha-' + vystraha.stupen + ' display-block vystraha-header'">
                    <div class="float-left vystraha-header-icon">
                      <img :src="'static/shmu/img/meteovystrahy/'+ vystraha.jav.jav_key.toLowerCase() + '.svg'" width="40">
                    </div>
                    <div class="float-left vystraha-header-jav">
                      <span class="font-weight-bold">{{ vystraha.jav.jav_popis }}</span>
                    </div>
                    <div class="float-right vystraha-header-stupen">
                      <strong>{{ vystraha.stupen}}. stupeň</strong>
                    </div>
                  </f7-card-header>
                  <f7-card-content>
                    <div class="vystraha-ctnt">
                      <div class="row">
                        <div class="col fs-075 margin-bottom-half">
                          <i class="f7-icons font-size-17">clock</i> od <strong>{{ vystraha.javod*1000 | moment('DD.MM.YYYY HH:mm') }}</strong>
                          do <strong>{{ (vystraha.javdo+1)*1000 | moment('DD.MM.YYYY HH:mm') }}</strong>

                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          {{ vystraha.vtext }}
                        </div>
                      </div>
                    </div>
                    <div class="vystraha-subctnt" v-if="vystraha.vietor">Vietor: <strong>{{ vystraha.vietor }}</strong></div>
                    <div class="vystraha-subctnt" v-if="vystraha.zrazky">Zrážky: <strong>{{ vystraha.zrazky }}</strong></div>
                    <div class="vystraha-subctnt" v-if="vystraha.sneh">Sneh: <strong>{{ vystraha.sneh }}</strong></div>
                    <div class="vystraha-subctnt" v-if="vystraha.dohladnost">Dohľadnosť: <strong>{{ vystraha.dohladnost }}</strong></div>
                    <div class="vystraha-subctnt" v-if="vystraha.teplota">Teplota: <strong>{{ vystraha.teplota }}</strong></div>
                  </f7-card-content>
                </f7-card>
              </template>
              <template v-else>
                <f7-block strong class="text-align-center no-margin-top">
                  Načítavam údaje...
                </f7-block>
              </template>

            </f7-block>

          </template>
        </f7-block>
      </f7-tab>
      <f7-tab id="tab-mv-map" class="wh-100" @tab:show="onMapTabShow($event)">

        <f7-fab position="right-bottom" slot="fixed" color="orange">
          <f7-icon ios="f7:plus" aurora="f7:plus" md="material:add"></f7-icon>
          <f7-icon ios="f7:xmark" aurora="f7:xmark" md="material:close"></f7-icon>
          <f7-fab-buttons position="top">
            <f7-fab-button label="Action 1">1</f7-fab-button>
            <f7-fab-button label="Action 2">2</f7-fab-button>
          </f7-fab-buttons>
        </f7-fab>


        <l-map :zoom="zoom"
               :center="center"
               :options="mapOptions"
               ref="mapMeteoVystrahy"
               class="meteo-vystrahy-map"
        >
          <l-control-zoom position="bottomright"  ></l-control-zoom>
          <l-tile-layer
              ref="layerBg"
              :url="url"
              :attribution="attribution"
          />
          <l-tile-layer :url="borderUrl" />
          <l-geo-json
              ref="geoJsonLayer"
              :geojson="meteoVystrahyGeoJsonData"
              :options-style="styleFunction"
              :options="geoJsonOptions"
          />
          <l-control
              :position="'bottomleft'"
          >

            <f7-button class="mv-javy-filter-btn text-color-white" fill v-if="allJavy.length > 1" popover-open=".mv-javy-popover" icon-f7="slider_horizontal_3"></f7-button>
            <f7-segmented raised tag="p" class="seg-map-buttons">
              <f7-button @click="selectedDay = 0" :class="{'button-active': selectedDay === 0}">Dnes</f7-button>
              <f7-button @click="selectedDay = 1" :class="{'button-active': selectedDay === 1}">Zajtra</f7-button>
              <f7-button @click="selectedDay = 2" :class="{'button-active': selectedDay === 2}">Pozajtra</f7-button>
            </f7-segmented>

          </l-control>

          <l-control v-if="isGeolocationEnabled" :position="'bottomright'">
            <div class="leaflet-bar">
              <a @click="geoLocateMap" role="button"><i class="icon f7-icons" style="font-size: 22px;">placemark_fill</i></a>
            </div>
          </l-control>

          <l-control v-if="isGeolocationEnabled && extraParams.clearBtnVar" :position="'bottomright'">
            <div class="leaflet-bar">
              <a @click="clearMarker" role="button"><i class="icon f7-icons" style="font-size: 22px;">xmark</i></a>
            </div>
          </l-control>



        </l-map>
      </f7-tab>
    </f7-tabs>


    <f7-popover class="mv-javy-popover">
      <f7-list>
        <f7-list-item checkbox v-for="(jav, index) in allJavy"
                      :checked="checkedJavy.indexOf(jav.jav_id) >= 0"
                      :value="jav.jav_id"
                      :key="index"
                      @change="updateJavyFilter"
                      popover-close
                      name="javy_filter[]"
                      :title="jav.jav_popis"
                      class="mv-jav-checkbox"

        >
        </f7-list-item>
      </f7-list>
    </f7-popover>

  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";
import { latLng } from "leaflet";
import { LMap, LTileLayer, LImageOverlay, LMarker, LGeoJson, LControlZoom, LControl } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import geoJsonMeteoMap from '../static/shmu/maps/meteo_map';
import searchMixin from "../js/mixin";
import shmuMixin from "../js/mixin";
import geoLocationMixin from "../js/geoLocationMixin";

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LImageOverlay,
    LGeoJson,
    LControlZoom,
    LControl
  },
  mixins: [
    searchMixin,
    shmuMixin,
    geoLocationMixin
  ],
  data: function () {
    return {
      latestAllWarnings: [],
      isAllWarningsLoaded: false,
      lastUpdatedAllWarnings: 0,
      regions: [],
      warningData: {},
      selectedRegion: null,
      isRegionsLoaded: false,
      isDataLoaded: false,
      lastUpdated: 0,
      tCheckInterval: null,
      selectedDay: 0,
      requestDt: this.$moment().unix(),
      dayRanges: [],
      checkedJavy: [],
      allJavy: [],
      rangeFrom: 0,
      rangeTo: 0,
      mapOptions: {
        zoomControl: false,
        zoomSnap: 0.5,
        maxBounds: [[51.7, 25.79], [45.05, 10.6]],
        minZoom: 6,
        maxZoom: 12
      },
      meteoVystrahyGeoJsonData: {
        "type": "FeatureCollection",
        "crs": {
          "type": "name",
          "properties": {
            "name": "EPSG:4326"
          }
        },
        "features": []
      },
      zoom: 6.5,
      center: latLng(48.688714, 19.696843),
      url: SHMUconf.MAP_TILE_URL + 'data/datatiles/osm/v1/{z}/{x}/{y}.png',
      borderUrl: SHMUconf.MAP_TILE_URL + 'data/datatiles/hranice_sk/v1/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright" class="external">OpenStreetMap</a> contributors',

      // geolocation
      extraParams: {
        circleMarkerObject: null,
        pointMarkerObject: null,
        clearBtnVar: false
      },

    };
  },
  computed: {
    currentRegion: function() {
      return this.regions.find((item) => item.region_key === this.selectedRegion);
    },
    geoJsonOptions() {
      return {
        onEachFeature: this.onEachFeatureFunction
      };
    },
    styleFunction() {
      // toto je tu kvoli tomu, aby sa funkcia pustila, ked nastane zmena v tychto reaktivnych premennych
      const myLatestData = this.latestAllWarnings;
      const mySelectedDay = this.selectedDay;
      const myCheckedJavy = this.checkedJavy;

      return (feature) => {
        let curfillColor = 'rgb(41, 214, 91)';
        if (myLatestData) {
          let obj = myLatestData.find(o => o.region_key === feature.properties.SKRATKA)
          if (typeof obj !== "undefined") {

            let vystrahy_len_pre_vybrany_den = obj.vystrahy.filter(
                item => (
                    myCheckedJavy.indexOf(item.jav.jav_id) >=0 &&
                    this.isVystrahaValidForRange(item.javod, item.javdo, this.rangeFrom, this.rangeTo)
                )

            );

            if (vystrahy_len_pre_vybrany_den.length > 0) {
              let max_stupen_vystraha = vystrahy_len_pre_vybrany_den.reduce(function (prev, current) {
                return (prev.stupen > current.stupen) ? prev : current
              })

              switch (max_stupen_vystraha.stupen) {
                case 1: {
                  curfillColor = 'rgb(255, 255, 1)';
                  break;
                }
                case 2: {
                  curfillColor = 'rgb(243, 138, 57)';
                  break;
                }
                case 3: {
                  curfillColor = 'rgb(254, 1, 4)';
                  break;
                }
              }

            }

          }
        }

        return {
          fillColor: curfillColor ,
          weight: 1,
          opacity: 0.8,
          color: 'black',
          fillOpacity: 0.8
        }


      };
    },
    onEachFeatureFunction() {
      const self = this;
      if (!this.latestAllWarnings) {
        return () => {};
      }
      return (feature, layer) => {
        let obj = self.latestAllWarnings.find(o => o.region_key === feature.properties.SKRATKA)
        if (typeof  obj !== "undefined") {
          layer.on({
            click: function (v) {
              self.$f7router.navigate('/meteo-vystrahy/' + v.target.feature.properties.SKRATKA);
            }
          });
        }
      };
    },

  },
  filters: {
    capitalize: function(s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
  },
  watch: {
    latestData: function() {
      this.isWarnings = this.latestData.length > 0;
    },
    latestAllWarnings: function () {
      this.meteoVystrahyGeoJsonData = geoJsonMeteoMap;

      let javy = [];
      this.allJavy = [];
      this.checkedJavy = [];
      this.latestAllWarnings.forEach(v => {
        v.vystrahy.forEach(j => {
          let res = javy.find(k => parseInt(k.jav_id) === parseInt(j.jav.jav_id));
          if (typeof res === "undefined") {
            javy.push(j.jav);
            this.allJavy.push(j.jav);
            this.checkedJavy.push(j.jav.jav_id);
          }
        });
      });


    },
    isRegionsLoaded: function () {
      if (this.selectedRegion === null) {
        this.$nextTick(() => {
          this.$f7.smartSelect.get('.meteo-vystrahy-ss-list .smart-select').open();
        });
      }
    },
    selectedDay() {
      this.populateRanges();
      this.$refs.mapMeteoVystrahy.mapObject.invalidateSize();
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');
    this.$nextTick(() => {
      this.initMap();
    });

  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        let cached_regions = self.$ls.get('meteo_warnings_regions');
        if (cached_regions !== null) {
          self.regions = cached_regions;
          self.selectedRegion = this.$ls.get('meteo_warnings_selected_region');
          self.isRegionsLoaded = true;
          self.loadWarningsData();
        } else {

          self.$f7.dialog.preloader('Načítavam...');

          Axios.get(SHMUconf.API_BASE_URL + 'meteo/getwarningsregions', {
            crossDomain: true,
            cache: false,
          })
              .then((response) => {
                if (!response.data.error) {
                  self.regions = response.data;
                  self.selectedRegion = this.$ls.get('meteo_warnings_selected_region');
                  self.isRegionsLoaded = true;
                  self.loadWarningsData();
                  self.$ls.set('meteo_warnings_regions', self.regions, 7 * 24 * 60 * 60 * 1000); // 7 dni
                } else {
                  self.$f7.dialog.alert('Nepodarilo sa načítať zoznam okresov pre meteo výstrahy', 'Nastala chyba');
                }
                self.$f7.dialog.close();

              }).catch((error) => {
            self.$f7.dialog.close();
            self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
          });
        }

      }

      if (this.isAllWarningsLoaded === true) {
        if ((this.$moment().unix() - this.lastUpdatedAllWarnings) > 60) {
          this.loadAllMeteoVystrahy();
        }
      }

    },
    onSelectForecast(event) {
      this.selectedRegion = event.target.value;
      this.loadWarningsData();
      this.$ls.set('meteo_warnings_selected_region', this.selectedRegion);
    },
    loadWarningsData() {
      const self = this;

      if (this.selectedRegion) {

        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'meteo/getwarnings?region=' + this.selectedRegion, {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.warningData = response.data;
                self.isDataLoaded = true;
                self.lastUpdated = self.$moment().unix();
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 60 * 1000); // overujem kazdu minutu

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať aktuálne meteorologické výstrahy', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },
    loadAllMeteoVystrahy: function() {
      const self = this;

      let cached = self.$ls.get('meteo_vystrahy');
      if (cached !== null) {
        self.requestDt = cached.request_dt;
        self.dayRanges = cached.dayranges;
        self.latestAllWarnings = cached.warningsdata;
        self.isAllWarningsLoaded = true;
        this.populateRanges();
      } else {

        self.$f7.dialog.preloader('Načítavam...');
        Axios.get(SHMUconf.API_BASE_URL + 'meteo/getwarnings?with_req_dt=1', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                self.requestDt = response.data.request_dt;
                self.dayRanges = response.data.dayranges;
                self.latestAllWarnings = response.data.warningsdata;
                self.isAllWarningsLoaded = true;
                self.lastUpdatedAllWarnings = self.$moment().unix();
                this.populateRanges();
                self.$ls.set('meteo_vystrahy', response.data, 50 * 1000); //  50 sekund
                // clearInterval(this.tCheckInterval);
                // this.tCheckInterval = setInterval(this.checkLastUpdated, 2 * 60 * 1000); // overujem kazdych 5 min

              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať údaje o meteorologických výstrahách', 'Nastala chyba');
              }
              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }
    },
    onMapTabShow(e) {
      // console.log('onMapTabShow');
      this.loadAllMeteoVystrahy();
      this.$refs.mapMeteoVystrahy.mapObject.invalidateSize();
    },
    onTableTabShow(e) {
      // console.log('onTableTabShow');
      this.pageReload(null, false);
    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    },
    initMap() {
      const self = this;

      this.$$('.leaflet-control-attribution a').each((i, item) => {
        self.$$(item).addClass('external')
      });

      // geolocation
      this.locationMapInitEvents(this, this.$refs.mapMeteoVystrahy.mapObject);

    },
    isVystrahaValidForRange(jav_od, jav_do, range_jav_od, range_jav_do) {
      // jav uz nie je platny pre aktualne obdobie
      if (jav_do < range_jav_od) {
        return false;
      } // ak uz jav nie je pre aktualny cas platny, false

      // jav zacina az v dalsom obdobi
      if (jav_od > range_jav_do) {
        return false;
      } // ak je jav od vacsi ako range jav do, ide do dalsieho obdobia, takze false

      // zacina v minulosti a konci v buducnosti (prelina 2-3 obdobia)
      if (jav_od <= range_jav_od &&  jav_do >= range_jav_do) {
        return true;
      } // ak je jav od skor a jav do neskor ako aktualne obdobie, tak vykreslujeme, true

      // zacina v sucasnom obdobi a konci v buducnosti
      if (jav_od >= range_jav_od &&  jav_do >= range_jav_do) {
        return true;
      }

      // zacina v sucasnom obdobi a konci v sucasnom obdobi
      if (jav_od >= range_jav_od && jav_do <= range_jav_do)  {
        return true;
      }

      // zacinanie v minulosti konci v sucasnoti
      if (jav_do <= range_jav_do && jav_do >= range_jav_od) {
        return true;
      } // ak je jav_do v ramci range jav do tak true

      return false;

    },
    populateRanges() {
      let res = this.dayRanges.find(item => parseInt(item.day) === this.selectedDay)
      if (typeof res !== "undefined") {
        this.rangeFrom = res.from;
        this.rangeTo = res.to;
      }
    },
    updateJavyFilter(event) {
      const self = this;

      let $chboxes_dom = self.$$('.mv-jav-checkbox input[type="checkbox"');
      if ($chboxes_dom.length > 0) {
        self.checkedJavy = [];
        $chboxes_dom.each(function(i, item) {
          if (self.$$(item).prop('checked')) {
            self.checkedJavy.push(parseInt(self.$$(item).val()))
          }
        });

        // ak nie je oznacena ani jedna, oznac vsetky
        if (self.checkedJavy.length === 0) {
          $chboxes_dom.each(function(i, item) {
            self.$$(item).prop('checked', true);
            self.checkedJavy.push(parseInt(self.$$(item).val()))
          });
        }

      }


    },
    onPageBeforeOut() {
      const self = this;
      // console.log('onPageBeforeOut');
      // Close opened sheets on page out
      self.$f7.popover.close();
    },
    onPageBeforeRemove() {
      const self = this;
      //   console.log('onPageBeforeRemove');
      // Destroy sheet modal when page removed
      if (self.popover) self.popover.destroy();
    },
    // geolocation
    geoLocateMap() {
      this.locationLocate(this, this.$refs.mapMeteoVystrahy.mapObject, 10);
    },
    clearMarker() {
      this.locationClearMarker(this, this.$refs.mapMeteoVystrahy.mapObject);
    },
    onLocationFound(e) {
      this.locationFound(this, this.$refs.mapMeteoVystrahy.mapObject, e);
    },
    onLocationError(e) {
      this.locationError(this, e);
    },
    selectOkresByLocation() {
      if (this.isGeolocationEnabled) {
        this.getGeoLocation(this.onLocationFoundAndSelectOkres, this.onLocationError)
      }
    },
    onLocationFoundAndSelectOkres(e) {
      this.currentLocation = e.coords;
      const self = this;

      if (this.currentLocation !== null) {


        // posli suradnice na backend a ziskaj okres
        Axios.get(SHMUconf.API_BASE_URL + 'global/getdistrictbylatlon?lat=' + this.currentLocation.latitude + '&lon=' + this.currentLocation.longitude, {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {
                let identifikovany_okres = response.data;
                this.selectedRegion = identifikovany_okres.okres_skratka;
                this.loadWarningsData();
                this.$ls.set('meteo_warnings_selected_region', this.selectedRegion);
                this.$f7.smartSelect.get('.meteo-vystrahy-ss-list .smart-select').setValue(this.selectedRegion);


              } else {
                self.$f7.dialog.alert('Nepodarilo sa identifikovať okres na základe vašich súradníc', 'Nastala chyba');
              }
              self.$f7.dialog.close();

            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });

      }

    },



  }

};
</script>

<style lang="scss">

.meteo-vystrahy-map {
  width: 100%;
  height: 100%;
}

.vystraha-ctnt {
  margin-bottom: 0.2rem;
}
.vystraha-subctnt {
  border-top: 1px solid var(--f7-list-border-color);
  padding: 0.4rem 0;
}

.vystraha-header-icon {
  line-height: 11px;
  padding-top:0px;
}
.vystraha-header-jav {
  line-height: 40px;
  margin-left:0.5rem;
}

.vystraha-header-stupen {
  line-height: 40px;
}

.ios {
  .vystraha-header {
    padding: 0.15rem 0.8rem;
  }
}

.seg-map-buttons {
  background: white;
  a {
    font-size: 0.8rem;
    width: 90px !important;
    &.button-active {
      color: white;
    }
  }
}

.mv-javy-filter-btn {
  width: 60px;
}

</style>
